module.exports = __webpack_public_path__ + "img/hill22.c0a1be2f.jpg";